export const cpscCoreFragment = `
  fragment cpscUiCoreFields on UsCpscPgaProgram {
    processingType
    programCode
    certificateType
    globalIdentifier {
      code
      type
    }
    intendedUseDetails {
      code
      description
    }
    certificateDeclaration {
      certified
    }
  }
`;
